<template>
  <div id="app">
    <my-header></my-header>
    <router-view class="main-content" />
  </div>
</template>

<script>
import MyHeader from '@/components/MyHeader'
export default {
  components:{
    MyHeader
  },
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP&display=swap");
:root {
  --main-color: #917d46;
  --weak-color: #aeaeae;
  --font-color: #000000;
  --bg-color: #ffffff;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

a {
  display: block;
  text-decoration: none;
}

ul {
  list-style: none;
}

button {
  border: none;
}
button:focus {
  outline: none;
}
#app {
  font-family: "Noto Sans JP", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--font-color);
}

.strong-font {
  font-weight: 700;
}

.mt-divide {
  margin-top: 60px;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
}

@media screen and (min-width: 380px) {
  body {
    font-size: 1.6em;
  }
}

@media screen and (min-width: 720px) {
  body {
    font-size: 2.2em;
  }
}

@media screen and (min-width: 1140px) {
  body {
    font-size: 1.4em;
  }
}
</style>
